"use client"

import styled from "@emotion/styled"
import { Box } from "@mui/material"
import { useTranslations } from "next-intl"
import Image from "next/image"
import "swiper/css"
import { sizes, useIsDesktop } from "ui"
import CommonTitle from "ui/common/bit/CommonTitle"
import { mediaQueries } from "ui/theme/mediaQueries"
import BlockWrapper from "../common/BlockWrapper"
import SwiperCarBoxesList from "./SwiperCarBoxesList"

export const StyledBlockWrapper = styled(BlockWrapper)`
  gap: ${sizes.baseSepta};
  ${mediaQueries.mobile} {
    gap: ${sizes.baseSix};
    padding: 0;
  }
`
export const StyledCommonTitle = styled(CommonTitle)`
  margin-bottom: 0;
  ${mediaQueries.mobile} {
    margin-bottom: 0;
  }
  ${mediaQueries.desktopM} {
    margin-bottom: 0;
  }
  ${mediaQueries.desktopXl} {
    margin-bottom: 0;
  }
`

const StyledBGImageContainer = styled(Box)`
  position: absolute;
  z-index: 0;
  height: 80%;
  width: 80%;
  left: -13%;
  bottom: -7%;
  img {
    object-fit: cover;
  }
  ${mediaQueries.desktopM} {
    inset: 0 -65px auto 0;
    width: 800px;
    height: 100%;
  }
  ${mediaQueries.desktop} {
    top: -56px;
    left: 0px;
  }
`

const CarBoxesListComponent = ({ data, id }: any) => {
  const { title, itemsList, subtitle } = data
  const isDesktop = useIsDesktop()
  const t = useTranslations("SEO")
  return (
    <StyledBlockWrapper id={id}>
      {(title || subtitle) && (
        <StyledCommonTitle title={title?.value} subtitle={subtitle?.value} />
      )}
      <SwiperCarBoxesList itemsList={itemsList} />
      <StyledBGImageContainer>
        <Image
          sizes="100vw"
          fill
          src={
            isDesktop
              ? "/hachsharaProtectClaim.svg"
              : "/hachsharaProtectClaimMobile.svg"
          }
          alt={`${t("backgroundImageAlt")}${title?.value}`}
        />
      </StyledBGImageContainer>
    </StyledBlockWrapper>
  )
}

export default CarBoxesListComponent
